import React, { createContext, FC, useContext } from "react";

import { ICompany } from "@/data/companies";
import { IConsultantProfile } from "@/data/consultant-profiles";

import { UserContext } from "./UserContext";

export interface IConsultantProfileContext {
  currentProfile: IConsultantProfile;
  currentProfileId: number;
  currentCompany?: ICompany;
  currentCompanyId?: number;
  setCurrentProfile: (profileId: IConsultantProfile["id"]) => void;
}

export const ConsultantProfileContext = createContext<IConsultantProfileContext>({} as IConsultantProfileContext);

export const ConsultantProfileProvider: FC = props => {
  const User = useContext(UserContext);

  const sessionUser = User.sessionUser;
  if (!sessionUser) {
    throw new Error("The session cannot be recognized.");
  }

  const sessionProfiles = sessionUser.consultantProfiles;
  if (sessionProfiles.length === 0) {
    throw new Error("No consultant profiles can be found.");
  }

  const currentProfileId = User.contextConsultantProfileId;
  const currentProfile = User.contextConsultantProfile;
  if (!currentProfileId || !currentProfile) {
    throw new Error("No consultant profile is selected.");
  }

  const setCurrentProfile = (profileId: IConsultantProfile["id"]) => {
    User.setConsultantProfileContext(profileId);
  };

  const context: IConsultantProfileContext = {
    currentProfileId,
    currentProfile,
    currentCompany: User.contextCompany,
    currentCompanyId: User.contextCompany && User.contextCompany.id,
    setCurrentProfile,
  };

  return <ConsultantProfileContext.Provider value={context}>{props.children}</ConsultantProfileContext.Provider>;
};
